import { forwardRef, type Ref } from "react";
import TextInput, { type TextInputProps } from "src/components/TextInput";
import Touchable from "src/components/Touchable";
import { useToggle } from "src/hooks";
import { Eye, VisibilityOff } from "src/icons";

const STYLES = {
  adornmentContainer: "mr-[18px] pointer-events-auto",
  icon: "text-gray-500 w-[22px]",
};

const PasswordInput = forwardRef(
  (
    {
      variant,
      defaultValue,
      disabled,
      onChange,
      error,
      className,
      autoComplete = "password",
      name = "password",
      label = "Password",
      hasVisibilityToggle = false,
    }: TextInputProps & {
      hasVisibilityToggle?: boolean;
    },
    ref: Ref<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { on: passwordVisible, toggle } = useToggle();

    const visibilityButton = (
      <Touchable className={STYLES.adornmentContainer} onClick={toggle}>
        {passwordVisible ? <VisibilityOff className={STYLES.icon} /> : <Eye className={STYLES.icon} />}
      </Touchable>
    );

    return (
      <TextInput
        variant={variant}
        name={name}
        disabled={disabled}
        label={label}
        type={passwordVisible ? "text" : "password"}
        autoComplete={autoComplete}
        ref={ref}
        defaultValue={defaultValue}
        onChange={onChange}
        error={error}
        className={className}
        adornment={hasVisibilityToggle && visibilityButton}
      />
    );
  }
);

export default PasswordInput;
